module.exports = __webpack_public_path__ + "img/demo-plano.c31d5c1a.jpg";